import type { FC, ReactNode } from 'react'
import React from 'react'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import clsx from 'clsx'

import Typography from '../Typography'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      borderRadius: '5px',
      height: '100%',
      maxHeight: '615px',
      maxWidth: '887px',
      overflow: 'hidden',
      border: '0.5px solid rgba(0,0,0,0.02)',
      boxShadow: '0 15px 20px 0 rgba(40,62,118,0.04)',
      backgroundColor: theme.colors.white,
      [theme.breakpoints.down('sm')]: {
        maxHeight: 'initial',
      },
    },
    container: {
      height: '100%',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    col: {},
    colRight: {
      background: 'linear-gradient(172.35deg, #9DE0EA 0%, #B7D6F1 100%)',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        height: 240,
        width: '100%',
      },
    },
    colLeft: {
      [theme.breakpoints.down('sm')]: {
        order: 1,
      },
    },
    logo: {
      maxWidth: '240px',
      marginBottom: theme.spacing(2.5),
    },
    content: {
      padding: theme.spacing(6.25, 7.5),
    },
    contentChildren: {
      marginTop: theme.spacing(2.375),
    },
    bgImage: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  }),
)

interface IProps {
  children?: ReactNode
  title?: string
}

const WelcomeBox: FC<IProps> = ({ children, title }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Grid className={classes.container} container spacing={0}>
        <Grid className={clsx(classes.col, classes.colLeft)} item md={6}>
          <div className={classes.content}>
            <img
              src="assets/images/homeviews-logo-dark.svg"
              alt="HomeViews logo"
              className={classes.logo}
            />
            {!!title && <Typography variant="h2">{title}</Typography>}
            <div className={classes.contentChildren}>{children}</div>
          </div>
        </Grid>
        <Grid className={clsx(classes.col, classes.colRight)} item md={6}>
          <img
            className={classes.bgImage}
            src="assets/images/login-building-mobile.jpg"
            alt="Login background"
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default WelcomeBox
